/**
 * TKP-172 — süreç üzerinden veri eklerken "Veri Kaynağı" sekmesi: kütüphane kaynağı seçilir, kaynağın öneri çiftlerindeki
 * veriler (library_pair_datasource_data) hepsi seçili gelir; kullanıcı kaldırır/ekler; kaydet seçilenleri mevcut
 * "kütüphaneden ekle" ucuyla (taslak kapısı dahil) düğüm olarak açar, seçilen kaynağın organizasyon karşılığını bağlar.
 * Saf: store/Vue yok.
 */
const idOf = (v) => String((v && v._id) || v || "");

/**
 * TKP-209: seçilen kaynağın öneri çiftlerinin bağlı olduğu kütüphane kaynağı — kütüphane seçimi kendisi, organizasyon kaynağı
 * kütüphane bağı (`libraryItem`) üzerinden; yeni ad ya da bağsız organizasyon kaynağında null (çift yok, veriler elle eklenir).
 */
export const libraryDatasourceIdOf = (datasource) => {
  if (!datasource || datasource.__new) return null;
  if (datasource.fromLibrary) return idOf(datasource) || null;
  return idOf(datasource.libraryItem) || null;
};

/** Çift listesinden veri kimlikleri (tekil, boşlar atılır). */
export const dataIdsOfPairs = (pairs = []) => [...new Set(pairs.map((p) => idOf(p && p.data)).filter(Boolean))];

/** Kaynağın verileri: kütüphane belgeleriyle eşleştirilmiş, hepsi seçili. Belgesi bulunmayan kimlik atlanır. */
export const sourceDataRows = (pairs = [], dataDocs = []) => {
  const byId = new Map(dataDocs.map((d) => [idOf(d), d]));
  return dataIdsOfPairs(pairs)
    .map((id) => byId.get(id))
    .filter(Boolean)
    .map((doc) => ({ _id: idOf(doc), doc, checked: true }));
};

/** Listede olmayan veriyi ekler (seçili); varsa yalnız seçili yapar. Girdi değiştirilmez. */
export const addRow = (rows = [], doc) => {
  const id = idOf(doc);
  if (!id) return rows;
  if (rows.some((r) => r._id === id)) return rows.map((r) => (r._id === id ? { ...r, checked: true } : r));
  return [...rows, { _id: id, doc, checked: true }];
};

export const toggleRow = (rows = [], id, checked) => rows.map((r) => (r._id === String(id) ? { ...r, checked: !!checked } : r));
export const setAll = (rows = [], checked) => rows.map((r) => ({ ...r, checked: !!checked }));
export const selectedDocs = (rows = []) => rows.filter((r) => r.checked).map((r) => r.doc);

// Kayıt sonucu sınıflandırma ve özet `unified-picker.js`e taşındı (TKP-184: "kaynağı eklendi" durumu eklendi; tek sekme de aynısını kullanır).

/** İki yerelleştirilmiş ad aynı mı (herhangi bir ortak dilde, boşluk/büyük-küçük duyarsız). */
export const sameLocalizedName = (a, b) => {
  if (!a || !b) return false;
  const norm = (v) => String(v || "").trim().toLocaleLowerCase("tr");
  return Object.keys(a).some((k) => a[k] && b[k] && norm(a[k]) === norm(b[k]));
};
